import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddCategory from './AddCategory';
import CategoriesTable from './AddSubcategories';

function MenuCategorization() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('categories'); // "categories" or "subcategories"

  return (
    <div className="p-6 bg-gray-100 min-h-screen flex flex-col">
      <header className="flex justify-between items-center mb-2 bg-white p-3">
        <h1 className="text-black text-xl font-bold ml-2">Menu Management</h1>
        <div className="flex space-x-6">
          <button onClick={() => navigate('/dashboard/mdm/menu-items-managment')} className="btn">
            Menu Items Management
          </button>
          <button
            onClick={() => navigate('/dashboard/mdm/menu-Categorization')}
            className="btn text-black font-bold"
          >
            Menu Categorization
          </button>
          <button
            onClick={() => navigate('/dashboard/mdm/menu-pricing-promotions')}
            className="btn "
          >
            Menu Pricing & Promotions
          </button>
          <button
            onClick={() => navigate('/dashboard/mdm/menu-analytics-insights')}
            className="btn "
          >
            Menu Analytics & Insights
          </button>
        </div>
      </header>
      <div className="mt-2 bg-white rounded-sm shadow-sm p-4">
        {/* Tab Navigation */}
        <div className="flex border-b mb-2">
          <button
            className={`px-6 py-3 font-medium text-sm ${
              activeTab === 'categories'
                ? 'border-b-2 border-black text-black'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('categories')}
          >
            Categories Management
          </button>
          <button
            className={`px-6 py-3 font-medium text-sm ${
              activeTab === 'subcategories'
                ? 'border-b-2 border-black text-black'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('subcategories')}
          >
            Subcategories Management
          </button>
        </div>

        {/* Tab Content */}
        <div className="p-4">
          {activeTab === 'categories' ? <AddCategory /> : <CategoriesTable />}
        </div>
      </div>
    </div>
  );
}

export default MenuCategorization;
